module.exports = __webpack_public_path__ + "media/images/promotions/banner-m-b931a6f57dbf39a179b9b9dc5f9fbd64.svg";